<template>
<div class="flex pwa__install cursor-pointer mb-4" :style="{
    backgroundColor: ThemeStore.loginPage.appBackgroundColor,
    color: ThemeStore.loginPage.appTextColor
}" v-if="canInstall" @click="install">
    <img :src="ThemeStore.loginPage.appIcon.url" alt="" v-if="ThemeStore.loginPage.appIcon && ThemeStore.loginPage.appIcon.url" class="pwa__install__logo">
    <div class="pwa__install__label flex  items-center w-full">Installer l'application</div>
</div>
</template>
<script>
import { useThemeStore } from "@/store/ThemeStore";
export default {
    data() {
        const ThemeStore = useThemeStore();   

        return {
            ThemeStore: ThemeStore,
            deferredPrompt: null,
            canInstall: false
        }
    },
    computed: {
        isInStandaloneMode: function() {
            return window.matchMedia('(display-mode: standalone)').matches;
        },
        isSafariDesktop: function() {
            const ua = navigator.userAgent;

            const isSafari =
                ua.includes("Safari") &&
                !ua.includes("Chrome") &&
                !ua.includes("Chromium") &&
                !ua.includes("Android");

            const isMac = navigator.platform.toUpperCase().includes("MAC");

            // Safari Desktop = Safari + macOS + pas mobile
            return isSafari && isMac;
        },
        isSafariIOS: function() {
            return (
                /iPhone|iPad|iPod/i.test(navigator.userAgent) &&
                navigator.userAgent.includes("Safari")
            );
        }
    },
    mounted() {
        window.addEventListener("beforeinstallprompt", e => {
            // Prevent Chrome 67 and earlier from automatically showing the prompt
            e.preventDefault();
            // Stash the event so it can be triggered later.
            this.deferredPrompt = e;

            this.canInstall = !this.isInStandaloneMode;
        });

        if (this.isSafariDesktop || this.isSafariIOS) {
            this.canInstall = !this.isInStandaloneMode;
        }
    },
    methods: {
        async dismiss() {
            this.deferredPrompt = null;
        },
        async install() {
            if (this.deferredPrompt) {
                this.deferredPrompt.prompt();
            } else {
                this.showManualInstructions()
            }
        },
        showManualInstructions() {
            // iOS spécifique
            const isiOS = /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

            let message = "Pour installer l'application :\r\n"

            if (isiOS && this.isSafariIOS) {
                message += "bouton (...) → bouton Partager (⬆︎) → Ajouter à l’écran d’accueil";
            } else if (this.isSafariDesktop) {
                message += "menu Safari → Fichier → Ajouter au Dock";
            } else {
                message += "Desktop : cherchez l’option “Installer l’application” dans le menu du navigateur (souvent à côté de la barre d’adresse).";
            }

            alert(message)
        }
    }
}
</script>